
import { ORACLE_PRICES_KEY } from '@/src/constants';
import { useNetwork } from '@/src/contexts';
import { useLocalStorage } from '@/src/hooks';
import { Button, Flex, Text, TradingSection } from '@/src/ui-components';
import { MoveRight } from 'lucide-react';
import { useMemo } from 'react';
import { defaultPricePairOracles, PricePairOracles } from '../../../oracles';
import { OraclePrice } from './oracle-price';

type OraclePricesProps = {
  onNavigateToManage?: () => void;
};

export const OraclePrices = ({ onNavigateToManage }: OraclePricesProps) => {
  const { value } = useLocalStorage<PricePairOracles>(ORACLE_PRICES_KEY, defaultPricePairOracles);
  const { isMainnet } = useNetwork();

  // Filter the oracles configured for the current network
  const valueOnCurrentNetwork = useMemo(() => {
    if (!value) return [];
    return value?.filter(
      (pricePairOracle) => pricePairOracle.network === (isMainnet ? 'xrpl:0' : 'xrpl:1')
    );
  }, [value, isMainnet]);

  let body: React.ReactNode = null;

  if (valueOnCurrentNetwork.length === 0) {
    body = (
      <Flex direction="col" gap="2">
        <Text size="sm">No Oracle data found.</Text>
        <Text size="sm">Create your first oracle configuration.</Text>
        <Flex justify="center">
          {onNavigateToManage && (
            <Button size="sm" onClick={onNavigateToManage}>
              <MoveRight />
              Manage Oracles
            </Button>
          )}
        </Flex>
      </Flex>
    );
  } else {
    body = (
      <>
        {valueOnCurrentNetwork.map((pricePairOracle, index) => (
          <Flex key={index} gap="2" align="center" justify="between" className="my-1">
            <Text as="span">
              {pricePairOracle.base_asset}/{pricePairOracle.quote_asset}
            </Text>
            <OraclePrice
              base_asset={pricePairOracle.base_asset}
              quote_asset={pricePairOracle.quote_asset}
              oracles={pricePairOracle.oracles}
            />
          </Flex>
        ))}
      </>
    );
  }

  return (
    <>
      <TradingSection>
        <TradingSection.Header>
          <TradingSection.Title>Oracles</TradingSection.Title>
        </TradingSection.Header>
        <TradingSection.Body>{body}</TradingSection.Body>
      </TradingSection>
    </>
  );
};
